type ModalViewport = {
  layoutHeight: number
  visualHeight?: number
  offsetTop?: number
  scale?: number
  editing: boolean
}

// O deslocamento elástico/pinch do Safari não representa a abertura do teclado.
// Só o teclado pode reduzir e reposicionar a área útil de um modal.
export function modalViewport({ layoutHeight, visualHeight = layoutHeight, offsetTop = 0, scale = 1, editing }: ModalViewport) {
  const keyboard = editing && Math.abs(scale - 1) < .01 && visualHeight < layoutHeight - 100
  return {
    height: Math.round(keyboard ? visualHeight : layoutHeight),
    top: keyboard ? Math.max(0, Math.round(offsetTop)) : 0,
  }
}
